import React, { useEffect, useState } from "react";
// import "./Dashboard.scss";
import RequestHandler from "../../Functions/RequestHandler";
import { toast, ToastContainer } from "react-toastify";
import TopProductsChart from "../../Component/TopProductChart.tsx";

import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	BarElement,
	Legend,
} from "chart.js";
import { Bar, Line } from "react-chartjs-2";
import ReportModal from "../../Component/ReportModal.tsx";

ChartJS.register(
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	BarElement,
	Title,
	Tooltip,
	Legend
);

export default function Dashboard({data, setData}) {
	const [totalOrders, setTotalOrders] = useState(0);
	const [topProducts, setTopProducts] = useState<any>([]);
	const [salesOverTime, setSalesOverTime] = useState<any>([]);
	const [totalSales, setTotalSales] = useState(0);
	const [userCount, setUserCount] = useState(0);
	const [productCount, setProductCount] = useState(0);
	const [categorySalesOrders, setCategorySalesOrders] = useState<any>([]);
	const [reportFilter, setReportFilter] = useState("this_week");

	const [modalOpen, setModalOpen] = useState(false);

	const [metrics, setMetrics] = useState<any>({
		totalSales: 0,
		totalOrders: 0,
		averageOrderValue: 0,
		topSellingProduct: "",
	});

	const loadRequestData = async () => {
		try {
			const data = await RequestHandler.handleRequest(
				"post",
				"orders/getAllOrderRevenue",
				{
					reportFilter: reportFilter,
				}
			);
			if (data.success === false) {
				toast.error(
					data.message ||
						"Error occurred. Please check your credentials."
				);
			} else {
				setData(data);
				setTotalOrders(data.totalOrders);
				setTotalSales(data.totalRevenue);
				setTopProducts(data.topProducts);
				setUserCount(data.userCount);
				setSalesOverTime(data.salesOverTime);
				setProductCount(data.productCount);
				setCategorySalesOrders(data.categorySalesOrders);
				setMetrics({
					totalSales: data.totalRevenue,
					totalOrders: data.totalOrders,
					averageOrderValue: data.averageOrderValue,
					topSellingProduct: data.topProducts.length > 0 ? data.topProducts[0].name : "NONE",
				});
			}
		} catch (error) {
			toast.error(`An error occurred while requesting data. ${error}`);
		}
	};

	useEffect(() => {
		loadRequestData();
	}, [reportFilter]);


	return (
		<div className="absolute bg-gray-50 top-[60px] left-[320px] w-[calc(100vw-330px)] p-6">
			<div className="dashboard-content space-y-8">
				<div className="dashboard-overview grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
					<div className="card bg-pink-50 shadow-xl rounded-lg p-6 flex flex-col justify-between items-start">
						<h3 className="text-lg font-semibold text-pink-600 mb-2">
							Total Sales
						</h3>
						<p className="text-4xl font-bold text-gray-800">
							₱ {totalSales}
						</p>
						<div className="text-pink-500 text-5xl mt-4">
							<i className="fa fa-dollar-sign"></i>
						</div>
					</div>

					<div className="card bg-pink-50 shadow-xl rounded-lg p-6 flex flex-col justify-between items-start">
						<h3 className="text-lg font-semibold text-pink-600 mb-2">
							Total Users
						</h3>
						<p className="text-4xl font-bold text-gray-800">
							{userCount}
						</p>
						<div className="text-pink-500 text-5xl mt-4">
							<i className="fa fa-users"></i>
						</div>
					</div>

					<div className="card bg-pink-50 shadow-xl rounded-lg p-6 flex flex-col justify-between items-start">
						<h3 className="text-lg font-semibold text-pink-600 mb-2">
							Total Products
						</h3>
						<p className="text-4xl font-bold text-gray-800">
							{productCount}
						</p>
						<div className="text-pink-500 text-5xl mt-4">
							<i className="fa fa-cogs"></i>
						</div>
					</div>

					<div className="card bg-pink-50 shadow-xl rounded-lg p-6 flex flex-col justify-between items-start">
						<h3 className="text-lg font-semibold text-pink-600 mb-2">
							Total Orders
						</h3>
						<p className="text-4xl font-bold text-gray-800">
							{totalOrders}
						</p>
						<div className="text-pink-500 text-5xl mt-4">
							<i className="fa fa-box"></i>
						</div>
					</div>
				</div>

				<div className="dashboard-charts grid grid-cols-1 lg:grid-cols-2 gap-8">
					<div className="chart-card bg-white shadow-xl rounded-lg p-6 space-y-4">
						<h3 className="text-lg font-semibold text-pink-600">
							Sales Over Time
						</h3>
						<div className="chart-placeholder h-[350px] w-full">
							{salesOverTime && salesOverTime.length > 0 ? (
								<Bar
									data={{
										labels: salesOverTime.map(
											(data) => data.month
										),
										datasets: [
											{
												label: "Revenue (₱)",
												data: salesOverTime.map(
													(data) =>
														parseFloat(data.revenue)
												),
												backgroundColor:
													"rgba(255, 99, 132, 0.5)",
											},
											{
												label: "Total Sales",
												data: salesOverTime.map(
													(data) => data.totalSales
												),
												backgroundColor:
													"rgba(54, 162, 235, 0.5)",
											},
										],
									}}
									options={{
										responsive: true,
										maintainAspectRatio: false,
										scales: {
											x: {
												title: {
													display: true,
													text: "Month",
												},
											},
											y: {
												title: {
													display: true,
													text: "Amount",
												},
											},
										},
										plugins: {
											tooltip: {
												mode: "index",
												intersect: false,
											},
											legend: {
												display: true,
												position: "top",
											},
										},
									}}
								/>
							) : (
								<p className="text-gray-500">
									No sales data available
								</p>
							)}
						</div>
					</div>

					<div className="chart-card bg-white shadow-xl rounded-lg p-6 space-y-4">
						<h3 className="text-lg font-semibold text-pink-600">
							Top Products
						</h3>
						<TopProductsChart topProducts={topProducts} />
					</div>
				</div>

				<div className="metrics-table bg-white shadow-xl rounded-lg p-6 mb-8">
					<div className="flex justify-between items-center mb-2">
						<h3 className="text-2xl font-semibold text-pink-600">
							Metrics Overview
						</h3>
						<div className="gap-3 flex">
							<button
								onClick={() => setModalOpen(true)}
								className="bg-green-500 text-white px-4 py-2 rounded-md"
							>
								Sales Report
							</button>
							<select
								className="bg-white border border-gray-300 text-gray-700 px-4 py-2 rounded-md"
								onChange={(e) =>
									setReportFilter(e.target.value)
								}
							>
								<option value="this_week">This Week</option>
								<option value="last_week">Last Week</option>
								<option value="weekly">Last 6 Weeks</option>
								<option value="monthly">Last 6 Months</option>
								<option value="annually">Last 6 Years</option>
							</select>
						</div>
					</div>
					<div className="overflow-x-auto">
						<table className="table-auto w-full border-collapse">
							<thead>
								<tr>
									<th className="px-6 py-4 text-left border-b font-medium">
										Metric
									</th>
									<th className="px-6 py-4 text-left border-b font-medium">
										Value
									</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td className="px-6 py-4 border-b">
										Total Sales
									</td>
									<td className="px-6 py-4 border-b">
										{metrics.totalSales} PHP
									</td>
								</tr>
								<tr>
									<td className="px-6 py-4 border-b">
										Total Orders
									</td>
									<td className="px-6 py-4 border-b">
										{metrics.totalOrders}
									</td>
								</tr>
								<tr>
									<td className="px-6 py-4 border-b">
										Average Order Value
									</td>
									<td className="px-6 py-4 border-b">
										₱{metrics.averageOrderValue}
									</td>
								</tr>
								<tr>
									<td className="px-6 py-4 border-b">
										Top-Selling Product
									</td>
									<td className="px-6 py-4 border-b">
										{metrics.topSellingProduct}
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<div className="category-sales-orders bg-white shadow-xl rounded-lg p-6">
					<h3 className="text-2xl font-semibold text-pink-600 mb-4">
						Category Sales Orders
					</h3>
					<div className="overflow-x-auto">
						<table className="table-auto w-full border-collapse">
							<thead>
								<tr>
									<th className="px-6 py-4 text-left border-b font-medium">
										Category
									</th>
									<th className="px-6 py-4 text-left border-b font-medium">
										Sales (PHP)
									</th>
									<th className="px-6 py-4 text-left border-b font-medium">
										Orders
									</th>
								</tr>
							</thead>
							<tbody>
								{categorySalesOrders.map((category, index) => (
									<tr key={index}>
										<td className="px-6 py-4 border-b">
											{category.category}
										</td>
										<td className="px-6 py-4 border-b">
											₱{category.sales}
										</td>
										<td className="px-6 py-4 border-b">
											{category.orders}
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<ReportModal
				data={data}
				setData={setData}
				isOpen={modalOpen}
				closeModal={() => setModalOpen(false)}
			/>
		</div>
	);



}
